import { useParams } from "react-router-dom"
import { useGetItem } from "./hooks"
import { Box, Divider, Grid, InputAdornment, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { formatTime, formattedDate } from "../../../lib/time"

const textFieldStyle = {
    fontFamily: 'Buenos Aires',
    maxWidth: '100%'
};

const fontStyle = {
    fontFamily: 'Buenos Aires',
}

const formFieldName = {
    fontSize: 12,
    fontWeight: '600',
    fontFamily: 'Buenos Aires'
}

const formFieldInput = {
    fontSize: 14,
    fontWeight: '600',
    color: '#1D2145',
    fontFamily: 'Buenos Aires'
}

const mainTitle = {
    fontWeight: 600,
    fontFamily: 'Rza',
    marginBottom: 0
}

const subTitle = {
    fontWeight: 600,
    fontFamily: 'Buenos Aires',
    fontSize: 14,
    color: '#75788F'
}

const boxText = {
    overflowWrap: 'anywhere',
    minHeight: '100px',
    border: '1px solid #D6D6E4',
    p: '8.5px 14px',
    borderRadius: '4px',
    fontFamily: 'Buenos Aires'
}


export const DailyReportFormExportNew = (props: any) => {
    const { id, reportId } = useParams()
    const { data } = useGetItem('daily-report', reportId)

    const rows = [
        createData('', '', '', ''),
        createData('', '', '', ''),
        createData('', '', '', ''),
        createData('', '', '', ''),
        createData('', '', '', ''),
    ];

    function createData(
        name: string,
        hr: string,
        code: string,
        desc: string,
    ) {
        return { name, hr, code, desc };
    }

    return (
        <>
            {data ? (
                <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2, marginBottom: 0 }}>
                    {/* --------------------START FIRST SECTION---------------------------------------- */}
                    <Box sx={{
                        color: '#979AAB',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '10px 0',
                        fontFamily: 'Buenos Aires',
                        fontWeight: '400',
                        fontSize: '11px',
                        lineHeight: '30px'
                    }}>
                        <Typography sx={fontStyle}>
                            CCC Applied Technology Bldg
                        </Typography>
                        <Typography sx={fontStyle}>
                            Form detail report
                        </Typography>
                    </Box>
                    <Divider />

                    <Box
                        sx={{ marginTop: 0, marginLeft: 2, marginRight: 2, marginBottom: 0 }}>
                        <Box sx={{
                            color: '#979AAB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            verticalAlign: 'top',
                            alignItems: 'end',
                            marginBottom: 0,
                            fontFamily: 'Buenos Aires'
                        }}>
                            <Box sx={{
                                height: '80px',
                                width: '130px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: '10px'
                            }}>
                                <Typography variant='h4' sx={{ fontWeight: '500', color: '#75788F', padding: '10px' }} gutterBottom>
                                    #{data?.reportNumber}
                                </Typography>
                            </Box>
                            <Box sx={{
                                height: '80px',
                                width: '130px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <Typography variant="h5" sx={{ margin: 'auto', fontWeight: 600, fontFamily: 'Rza', backgroundColor: '#2499EF', color: '#fff', padding: '10px' }}>
                                    Bynaus
                                </Typography>
                            </Box>

                        </Box>

                        <Typography variant='h4' gutterBottom sx={{ fontWeight: 600, fontFamily: 'Rza', marginBottom: 3 }}>
                            Daily Report {formattedDate(data.date)}
                        </Typography>
                        <Box sx={{ fontFamily: 'Buenos Aires', fontSize: '11px' }}>
                            <Grid container spacing={0} >
                                <Grid item xs={12}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={2}>
                                            <Typography sx={formFieldName}>Location:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={10}
                                            sx={formFieldInput}>
                                            {data?.activityLocation}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box sx={{ fontFamily: 'Buenos Aires', fontSize: '11px' }}>
                            <Grid container spacing={0} >
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Form Date:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {formattedDate(data.date)}                                         
                                        </Grid>  
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Created By:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {data?.clientName}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Due Date:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {formattedDate(data?.project?.projectDueDate)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                    <Grid container alignItems={"center"}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Description:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {data?.project?.projectDescription}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Status:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            <Box sx={{
                                                width: 'fit-content',
                                                backgroundColor: '#E1FAD9',
                                                color: '#537212',
                                                borderRadius: '16px',
                                                padding: '5px 10px',
                                                textTransform: 'uppercase',
                                                fontWeight: '600',
                                                // fontFamily: 'Open Sans,Montserrat,sans-serif',
                                                fontSize: 12,
                                            }}>
                                                In Progress
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} >
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Last Update:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {formattedDate(data?.updatedAt) + ' ' + formatTime(data?.updatedAt)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0}>
                                <Grid item xs={5} sx={{ marginRight: '30px' }}>
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Included References:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {'Assets | Files | Forms | Issues | Photos'}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={5} >
                                    <Grid container alignItems={"center"} sx={{ borderBottom: 1, borderColor: 'divider', padding: '10px 0', height: '100%' }}>
                                        <Grid sx={{ color: '#75788F', textTransform: 'uppercase' }} item xs={5}>
                                            <Typography sx={formFieldName}>Last Updated By:</Typography>{' '}
                                        </Grid>
                                        <Grid item xs={7}
                                            sx={formFieldInput}>
                                            {data?.clientName}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    {/* --------------------END FIRST SECTION---------------------------------------- */}

                    <Box
                        sx={{ marginTop: 1, marginLeft: 2, marginRight: 2, fontFamily: 'Rza' }}>
                        <Box
                            sx={{ marginTop: 1, borderBottom: 1, borderColor: 'divider' }}>
                            {/* <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'end',
                                marginBottom: 5,
                                marginTop: 3,
                            }}> */}
                            <Grid container spacing={0} sx={{ padding: '10px 0px' }}>
                                <Grid item xs={6}>
                                    <Box>
                                        <Box sx={{
                                            height: '100px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontFamily: 'Rza'
                                        }}>
                                            <Typography variant="h5" sx={{ margin: 'auto', fontWeight: 600, backgroundColor: '#2499EF', color: '#fff', padding: '10px', fontFamily: 'Rza' }}>
                                                Bynaus
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={6}>
                                    <Box sx={{ color: '#75788F', textTransform: 'uppercase', lineHeight: '20px', fontWeight: 700 }}>
                                        <Typography sx={{ fontSize: 13, fontWeight: 500, marginBottom: 2, lineHeight: '20px', fontFamily: 'Buenos Aires' }}>390 Selby Street San Francisco, CA 94124</Typography>
                                        <Divider />
                                        <Grid container spacing={1} sx={{ padding: '10px 0px', fontSize: 13, fontFamily: 'Buenos Aires' }}>
                                            <Grid item xs={3}>Phone</Grid>
                                            <Grid item xs={9} sx={{ color: '#1D2145', fontWeight: "600" }}>(415)  508-4968</Grid>
                                        </Grid>
                                        <Divider />
                                        <Grid container spacing={1} sx={{ padding: '10px 0px', fontSize: 13, fontFamily: 'Buenos Aires' }}>
                                            <Grid item xs={3}>Fax</Grid>
                                            <Grid item xs={9} sx={{ color: '#1D2145', fontWeight: "600" }}>(415)  508-4585</Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            {/* </Box> */}
                            </Grid>
                        </Box>

                        <Box sx={{ color: '#979AAB', textTransform: 'uppercase', marginTop: 3, marginBottom: 2, fontFamily: 'Buenos Aires' }}>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                            Job No:
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <TextField size="small" value={data?.projectNumber} sx={{
                                                maxWidth: '100%',
                                                '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                            }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={6}>
                                            <Grid container alignItems={'center'} sx={{ fontFamily: 'Buenos Aires' }}>
                                                <Grid item xs={12} sm={5} sx={{ color: '#75788F' }}>
                                                    Report No:
                                                </Grid>
                                                <Grid item xs={12} sm={7}>
                                                    <TextField size="small" value={data?.reportNumber} sx={{
                                                        maxWidth: '100px',
                                                        '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                                    }} variant="outlined" />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Grid container alignItems={'center'}>
                                                <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                                    Date:
                                                </Grid>
                                                <Grid item xs={12} sm={9}>
                                                    <TextField size="small" value={data?.date} sx={{
                                                        width: '100px',
                                                        '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                                    }} variant="outlined" />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 13, alignItems: 'center', fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                            Project:
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <TextField size="small" value={data?.project?.projectName} fullWidth sx={{
                                                '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                            }} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                            Weather:
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <TextField size="small" fullWidth sx={{
                                                // maxWidth: '100px',
                                                '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                            }}
                                                // InputProps={{
                                                //     endAdornment: (
                                                //         <InputAdornment position="end" sx={{
                                                //             '& .MuiTypography-root': { fontFamily: 'Buenos Aires' }
                                                //         }} >
                                                //             °F
                                                //         </InputAdornment>
                                                //     ),
                                                // }} 
                                                 value={data?.weather} 
                                                 variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={12}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sx={{ color: '#75788F' }}>
                                            Activity Location:
                                        </Grid>
                                        <Grid item xs={12}>
                                            {/* <TextField size="small" value={data?.project?.locations[0].address} fullWidth sx={{ maxWidth: '100%' }} variant="outlined" /> */}
                                            <Typography sx={{ overflowWrap: 'anywhere', color: '#000', minHeight: '50px', fontSize: 13, border: '1px solid #D6D6E4', p: '8.5px 14px', borderRadius: '4px', fontFamily: 'Buenos Aires' }} >
                                                {data?.project?.locations[0].address}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F' }}>
                                            Client / GC:
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <TextField size="small" fullWidth sx={{
                                                maxWidth: '100%',
                                                '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                            }} 
                                            value={data?.clientName} 
                                            variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={2} sx={{ color: '#75788F' }}>
                                            Craft:
                                        </Grid>
                                        <Grid item xs={12} sm={10}>
                                            <TextField size="small" fullWidth sx={{
                                                maxWidth: '100%',
                                                '& .MuiInputBase-input': { fontFamily: 'Buenos Aires' }
                                            }} 
                                            value={data?.service} 
                                            variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box>
                            <Grid container spacing={2} sx={{ padding: '10px 0px', fontSize: 13, fontWeight: 600, marginTop: 10, marginBottom: 1 }} >
                                <Grid item xs={12}>
                                    <Typography variant='h5' gutterBottom sx={{ fontWeight: 600, fontFamily: 'Rza' }}>
                                        Timesheets
                                    </Typography>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow sx={{
                                                ' th': {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '8px 10px',
                                                    color: '#75788F',
                                                    textTransform: 'uppercase',
                                                    fontSize: 12,
                                                    fontFamily: 'Buenos Aires'
                                                }
                                            }}>
                                                <TableCell>Name</TableCell>
                                                <TableCell>HR</TableCell>
                                                <TableCell>Code</TableCell>
                                                <TableCell>Description of Work</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.timesheets && data.timesheets.length > 0 ? data.timesheets.map((ts: any, i: number) => (
                                                <TableRow
                                                    key={i}
                                                    sx={{
                                                        ' td': {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            backgroundColor: i % 2 === 0 ? '#F5F5FD' : '',
                                                            fontFamily: 'Buenos Aires'
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell>{ts.user?.lastName}, {ts.user?.firstName}</TableCell>
                                                    <TableCell>{ts.formattedTimeDurations?.totalTimeWorked}</TableCell>
                                                    <TableCell>
                                                        {ts.costCodes ? ts.costCodes?.map((cc: any, x: number) => {
                                                                return (
                                                                    <div key={'costCodeLabel_'+x}>
                                                                        {cc.costCode.label} - {cc.formattedTimeDuration} <br />
                                                                    </div>
                                                                )
                                                            })
                                                        : null }
                                                    </TableCell>
                                                    <TableCell>
                                                        {ts.costCodes ? ts.costCodes?.map((cc: any, x: number) => {
                                                                return (
                                                                    <div key={'costCodeDesc_'+x}>
                                                                        {cc.description || ''} <br />
                                                                    </div>
                                                                )
                                                            })
                                                        : null }
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                            :   <TableRow
                                                    key='timesheet'
                                                    sx={{
                                                        ' td': {
                                                            border: 1,
                                                            borderColor: '#D6D6E4',
                                                            padding: '5px 10px',
                                                            backgroundColor: '#F5F5FD',
                                                            fontFamily: 'Buenos Aires'
                                                        },
                                                        height: '25px'
                                                    }}
                                                >
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ marginBottom: 3 }}>
                            <Typography variant='h5' gutterBottom sx={{ fontWeight: 600, fontFamily: 'Rza' }}>
                                Equipment
                            </Typography>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow sx={{
                                        ' th': {
                                            border: 1,
                                            borderColor: '#D6D6E4',
                                            padding: '8px 10px',
                                            color: '#75788F',
                                            textTransform: 'uppercase',
                                            fontSize: 12,
                                            fontFamily: 'Buenos Aires'
                                        }
                                    }}>
                                        <TableCell>Description <span style={{ fontSize: 10, textTransform: 'none' }}>&nbsp; (Scissorlift,  Boom Lift, etc.)</span></TableCell>
                                        <TableCell>Qty</TableCell>
                                        <TableCell>Equipment Supplier</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.equipment?.map((e: any, i: number) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                ' td':
                                                {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '5px 10px',
                                                    backgroundColor: i % 2 === 0 ? '#F5F5FD' : '',
                                                    fontFamily: 'Buenos Aires'
                                                },
                                                height: '25px'
                                            }}
                                        >
                                            <TableCell>{e?.lineItemValue}</TableCell>
                                            <TableCell>{e?.quantity}</TableCell>
                                            <TableCell>{e?.supplier}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>

                        <Box sx={{ marginBottom: 3 }}>
                            <Typography variant='h5' gutterBottom sx={{ fontWeight: 600, fontFamily: 'Rza', marginBottom: 2 }}>
                                Material Delivered to Site Today
                            </Typography>
                            <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow sx={{
                                        ' th': {
                                            border: 1,
                                            borderColor: '#D6D6E4',
                                            padding: '8px 10px',
                                            color: '#75788F',
                                            textTransform: 'uppercase',
                                            fontSize: 12,
                                            fontFamily: 'Buenos Aires'
                                        }
                                    }}>
                                        <TableCell>Description </TableCell>
                                        <TableCell>Qty</TableCell>
                                        <TableCell>Equipment Supplier</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.materialsDelivered?.map((m: any, i: number) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                ' td': {
                                                    border: 1,
                                                    borderColor: '#D6D6E4',
                                                    padding: '5px 10px',
                                                    backgroundColor: i % 2 === 0 ? '#F5F5FD' : '',
                                                    fontFamily: 'Buenos Aires'
                                                },
                                                height: '25px'
                                            }}
                                        >
                                            <TableCell>{m?.lineItemValue}</TableCell>
                                            <TableCell>{m?.quantity}</TableCell>
                                            <TableCell>{m?.supplier}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>

                        <Box sx={{ marginBottom: 3 }}>
                            <Typography variant='h5' gutterBottom sx={mainTitle}>
                                List Work Performed Today
                            </Typography>
                            <span style={subTitle}>
                                Include Any Special conditions & comments (delays, conflicts, hold-up's, etc.)
                            </span>
                            <Box sx={{ marginTop: 2, overflowWrap: 'anywhere' }}>
                                <Typography sx={boxText} >
                                    {data?.workPerformed}
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ marginBottom: 3 }}>
                            <Typography variant='h5' gutterBottom sx={mainTitle}>
                                All items listed below are causing a delay(s)
                            </Typography>
                            <span style={subTitle}>
                                All items listed below are causing a delay(s) to DMS' progress & following activities.  Time/Cost impacts will be addressed at later date.
                            </span>
                            <Box sx={{ marginTop: 2 }}>
                                {data?.delaysAndImpacts?.map((delays: any, i: number) =>
                                    <Typography key={i} sx={boxText} >
                                        {delays?.lineItemValue}
                                    </Typography>
                                )}
                            </Box>
                        </Box>

                        <Box sx={{ color: '#979AAB', textTransform: 'uppercase', marginBottom: 1 }}>
                            <Grid container spacing={2} sx={{ justifyContent: 'space-between', padding: '10px 0px', fontSize: 13, fontWeight: 600, marginBottom: 2 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F', fontFamily: 'Buenos Aires' }}>
                                             Foreman:
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" value={data.foreman} fullWidth sx={textFieldStyle} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={4} sx={{ color: '#75788F', fontFamily: 'Buenos Aires' }}>
                                            Project Manager:
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <TextField size="small" value={data.projectManager} fullWidth sx={textFieldStyle} variant="outlined" />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ justifyContent: 'space-between', padding: '10px 0px', fontSize: 13, fontWeight: 600 }} >
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={3} sx={{ color: '#75788F', fontFamily: 'Buenos Aires' }}>
                                            Signature:
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <TextField size="small" value={data.foremanSignature} multiline rows={2} fullWidth variant="outlined" sx={textFieldStyle} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                    <Grid container alignItems={'center'}>
                                        <Grid item xs={12} sm={4} sx={{ color: '#75788F', fontFamily: 'Buenos Aires' }}>
                                            Signature:
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <TextField size="small" value={data.projectManagerSignature} multiline rows={2} fullWidth variant="outlined" sx={textFieldStyle} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            ) : null}
        </>
    )
}